import axios from 'axios'

export default function () {
  async function getApi(urlApi, path) {
    const url = `${urlApi}${path}`
    const resp = await axios
      .get(url)
      .then(response => response.data)
      .catch(() => null)
    return resp
  }
  async function postApi(urlApi, path, player) {
    const url = `${urlApi}${path}`
    const resp = await axios
      .post(url, JSON.stringify(player))
      .then(response => response.data)
      .catch(() => null)
    return resp
  }
  async function postApiJson(urlApi, path, player) {
    const url = `${urlApi}${path}`
    const resp = await axios
      .post(url, player) // <--- ¡Pásalo directo! Sin JSON.stringify()
      .then(response => response.data)
      .catch(() => null)

    return resp
  }

  async function postApiFormData(urlApi, path, objeto) {
    const URL = `${urlApi}${path}`
    const resp = await axios({
      method: 'POST',
      headers: {
        'content-type': 'multipart/form-data',
      },
      url: URL,
      data: objeto,
    }).then(response => response.data)
      .catch(() => null)
    return resp
  }
  // eslint-disable-next-line
  return { getApi, postApi, postApiJson, postApiFormData }
}
